import * as React from 'react';
import {
  useTranslations,
  withTranslationsProvider,
} from '@narvar/nth-hook-translations';
import Button from '@narvar/nth-block-button';
import { MediumHeader } from '@narvar/nth-bit-header';
import {
  useDeliveryInstructionsContext,
  UI_STATE,
} from '../../hooks/useDeliveryInstructionsState';
import StepHeader from '../StepHeader';
import CustomComponentContext from '../CustomComponentContext';
import { ResponseDeliveryInstructionsEligibility } from '../../../server/api/schema';

interface InitialPanelProps {
  eligibility: ResponseDeliveryInstructionsEligibility | null;
}

const InitialPanel: React.FunctionComponent<InitialPanelProps> = (props) => {
  const { eligibility } = props;
  const { state, track } = React.useContext(CustomComponentContext);
  const { update: updateUIState } = useDeliveryInstructionsContext();

  const { featureName } = state?.settings || { featureName: '' };

  const {
    deliveryInstructionsInitialHeaderText: headerText,
    // deliveryInstructionsInitialHeaderWithASRText: asrHeaderText,
    deliveryInstructionsInitialButtonText: buttonText,
    // deliveryInstructionsInitialButtonWithASRText: asrButtonText,
  } = useTranslations();

  // Temporary until translation is added to quin
  // Remove once translation is available
  const asrHeaderText =
    'Your shipment requires a signature. Would you like to pre-sign for the package and let your driver know where to leave it?';
  const asrButtonText = 'Manage Delivery';

  const onClick = (): void => {
    track({
      eventType: 'click',
      clickSubType: 'initiate',
    });
    updateUIState({
      deliveryInstructionsUIState: UI_STATE.ADDRESS_VERIFICATION,
      stepNavigationChange: true,
      asrSignatureRequired: eligibility?.asrSignatureRequired,
    });
  };

  return (
    <div style={{ padding: '0.25rem 0.75rem' }}>
      <StepHeader>
        <MediumHeader
          featureName={typeof featureName === 'string' ? featureName : ''}
          containerCustomStyle={{ margin: '0 0 1rem 0' }}
          as="h2"
        >
          {eligibility?.asrSignatureRequired ? asrHeaderText : headerText}
        </MediumHeader>
      </StepHeader>
      <Button onClick={onClick}>
        {eligibility?.asrSignatureRequired ? asrButtonText : buttonText}
      </Button>
    </div>
  );
};

export default withTranslationsProvider(InitialPanel, {
  translationKeys: [
    'deliveryInstructionsInitialHeaderText',
    // 'deliveryInstructionsInitialHeaderWithASRText',
    'deliveryInstructionsInitialButtonText',
    // 'deliveryInstructionsInitialButtonWithASRText',
  ],
});
